import { configureStore } from '@reduxjs/toolkit'
import { baseApi } from './api/baseApi'
import toastReducer from './toastSlice'
import authReducer from './authSlice'
import invoicesReducer from './invoicesSlice'

export const store = configureStore({
	reducer: {
		[baseApi.reducerPath]: baseApi.reducer,
		toast: toastReducer,
		auth: authReducer,
		invoices: invoicesReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(baseApi.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

